<template>
  <RouterView />
</template>

<script setup lang="ts">
  // Main app component with router
</script>
